module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "BlogArticle"
  }, [_c('header', {
    staticClass: "BlogArticle-header"
  }, [_c('h2', {
    staticClass: "BlogArticle-title t-heading-md"
  }, [_c(_vm.route ? 'router-link' : 'span', {
    tag: "component",
    attrs: {
      "to": _vm.route
    }
  }, [_vm._v("\n\n        " + _vm._s(_vm.post.attributes.title) + "\n\n      ")])], 1), _vm._v(" "), (_vm.showDate) ? _c('p', {
    staticClass: "BlogArticle-date t-text-sm"
  }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.date, 'mmmm d, yyyy')) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "BlogArticle-content"
  }, [_c('markdown', {
    attrs: {
      "content": _vm.post.body
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82783ff6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogArticle.vue
// module id = 785
// module chunks = 1474